import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Paper from '@material-ui/core/Paper';
import Typography from '@material-ui/core/Typography';
import LoginForm from '../LoginForm/LoginForm'

const styles = theme => ({
  root: {
    // paddingTop: 16,
    // paddingBottom: 16,
    // marginTop: theme.spacing.unit * 3,
    position: 'absolute',
    display: 'flex',
    height: '100%',
    width: '100%',
    justifyContent: 'center',
    alignItems: 'center'
  },
  paper: theme.mixins.gutters({
    paddingTop: 16,
    paddingBottom: 16,
    // marginTop: theme.spacing.unit * 3,
    justify: 'center',
    alignItems: 'center',
    textAlign: 'center'
  })
});

class Login extends Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.root}>
        <Paper className={classes.paper} elevation={4}>
          <Typography variant="headline" component="h3">Login</Typography>
          {/* <Typography component="p">
            Paper can be used to build surface or other elements for your application.
          </Typography> */}
          <LoginForm />
        </Paper>
      </div >
    )
  }
}

Login.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Login);



// WEBPACK FOOTER //
// ./src/components/Login/Login.jsx